
import { Component, Prop, PropSync } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DateFormatMixin, HeMixin } from "@/mixins";
import { CDataTableFields } from '@/@types';
import { TaskScheduleFilterQueryPayload, TaskSchedule } from '@/store/modules';

@Component({
  components: {}
})
export class TechnicianScheduleList extends mixins(DateFormatMixin, HeMixin) {
  @Prop({ default: () => [] })
  private items!: TaskSchedule[];

  @Prop({ default: () => false })
  private loading!: boolean;

  @Prop({ default: () => 0 })
  private total!: boolean;

  @Prop({ default: () => true })
  private itemsPerPageSelect!: boolean;

  @PropSync("itemsPerPage", { default: () => 25, type: Number })
  itemsPerPageSync!: number;

  @PropSync("columnFilterValue", { default: () => ({}), type: Object })
  columnFilterValueSync!: TaskScheduleFilterQueryPayload;

  @PropSync("sorterValue", { default: () => ({}), type: Object })
  sorterValueSync!: { column: string | null; asc: string | boolean };

  page = 1;

  fields: CDataTableFields = [
    { key: "start", label: "Start" },
    { key: "end", label: "End" },
    { key: "durationHours", label: "Duration" },
    { key: "description", label: "Desc" },
    { key: "complete", label: "Complete" }
  ];

  onTotalPageChange(val: number) {
    this.itemsPerPageSync = val;
  }

  onColumnFilterChange(val: TaskScheduleFilterQueryPayload) {
    this.columnFilterValueSync = val;
  }

  onSorterValueChange(val: { column: string; asc: boolean }) {
    this.sorterValueSync = val;
  }
}
export default TechnicianScheduleList;
